<template>
    <div>
        <van-search v-model="country" @input="countrySearch"></van-search>
        <van-picker
                show-toolbar
                :default-index="defaultIndex"
                :columns="countryActions"
                value-key="label"
                @cancel="onCancel"
                @confirm="onConfirm"
        />
    </div>

</template>

<script>
    export default {
        name: "CountryPicker",
        props: {
            defaultIndex: {
                type: Number
            },
            columns: {
                type: Array
            }
        },
        data() {
            return {
                country: '',
                countryActions: [],
                completeCountryActions: []
            }
        },
        created() {
            this.countryActions = this.columns;
            this.completeCountryActions = this.columns;
        },
        methods: {
            countrySearch(){
                if (this.country.length > 1){
                    this.countryActions = this.countryActions.filter(item => item.label.indexOf(this.country.toUpperCase()) !== -1);
                }else {
                    this.countryActions = this.completeCountryActions;
                }
            },
            onConfirm(item) {
                this.$emit('confirm', item);
            },
            onCancel() {
                this.$emit('close');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .van-form .van-cell.van-field {
        margin-bottom: 0 !important;
    }
</style>
